export default function HelperText() {
  return (
    <div className='flex flex-col mt-7'>
      <span className='text-status-text-out-of-form text-[16px]'>
        Regular funds have a higher expense ratio than Direct funds, which lowers your returns. With this plan, switch to Direct funds, tax-efficiently.
      </span>
    </div>
  )
}
